export default "__VITE_ASSET__6ec4cf2f__"